const config = {
  // apiBaseURL: 'http://localhost:1337',
  apiBaseURL: 'https://finance-app-sever-82c3ed501308.herokuapp.com'
}; 

export default config;